import { createContentPropTypes } from '../../../helpers/content';

const content = {
	footerActiveDDListMsg: 'Any new Direct Debits you set up will appear here.',
	footerActiveSOListMsg: 'Any new standing orders you set up will appear here.',
	footerActiveOtherListMsg: 'Any new scheduled payments you set up will appear here.',
	footerActiveAllListingMsg: 'Any new scheduled payments you set up will appear here.',
	footerArchiveListingMsg: "That's all of them. Any archived payments will appear here.",
	somethingWentWrongMsg: 'Something went wrong.',
	retryButtonlabel: 'Retry',
	viewButtonLabel: 'View',
	cancelButtonLabel: 'Cancel',
	editButtonLabel: 'Edit',
	noResultsAllPayments: "You don't have any scheduled payments.",
	noResultsDD: "You don't have any direct debits.",
	noResultsSO: "You don't have any standing orders.",
	noResultsOther: "You don't have any other scheduled payments.",
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
